import * as yup from 'yup';
import type { MultiSelectOption } from './CommonTypes';

export const LINE_OF_BUSINESS_REQUIRED_MESSAGE = 'Line of Business is required';
export const STRATEGIC_BUSINESS_UNIT_REQUIRED_MESSAGE =
  'Strategic Business Unit is required';
export const EXPOSURE_NUMBER_REQUIRED_MESSAGE = 'Exposure Number is required';

export const LineOfBusinessOptions: MultiSelectOption[] = [
  { title: 'APD', value: 'APD' },
  { title: 'Casualty', value: 'Casualty' },
  { title: 'Property', value: 'Property' },
];

export const StrategicBusinessUnitOptions: MultiSelectOption[] = [
  { title: 'USRM', value: 'USRM' },
  { title: 'GRS', value: 'GRS' },
  { title: 'State Auto', value: 'State Auto' },
  { title: 'USRM PL', value: 'USRM PL' },
  { title: 'USRM BL', value: 'USRM BL' },
];

export const ClaimSystemOptions: MultiSelectOption[] = [
  { title: 'Navigator', value: 'Navigator' },
  { title: 'BLCC', value: 'BLCC' },
  { title: 'ClaimCenter', value: 'ClaimCenter' },
];

/**
 * The qualified create flow's required billing details. The whole object may
 * be undefined (no referral detail touched yet); yup casts that to an object
 * of undefined fields, so each field still reports its own named message.
 */
export const buildReferralDetailsSchema = (): yup.AnyObjectSchema =>
  yup.object({
    lineOfBusiness: yup
      .string()
      .nullable()
      .required(LINE_OF_BUSINESS_REQUIRED_MESSAGE),
    strategicBusinessUnit: yup
      .string()
      .nullable()
      .required(STRATEGIC_BUSINESS_UNIT_REQUIRED_MESSAGE)
      .oneOf(
        StrategicBusinessUnitOptions.map((option) => String(option.value)),
        STRATEGIC_BUSINESS_UNIT_REQUIRED_MESSAGE
      ),
    exposureNumber: yup
      .string()
      .nullable()
      .required(EXPOSURE_NUMBER_REQUIRED_MESSAGE),
  });
